<template>
  <div class="clientsAdd">
    <div class="pageContent">
      <heading-wrap>
        <span slot="title">Edit your profile</span>
      </heading-wrap>
      <spinner v-if="loading" />
      <form v-if="user">
        <form-group>
          <field name="Name" :value="user.name" v-model="user.name"/>
        </form-group>
        <form-group>
          <field name="Email" :value="user.email" type="email" readOnly/>
        </form-group>
        <form-group>
          <field name="New Password" :value="user.newPassword" type="password" v-model="user.newPassword"/>
        </form-group>
        <form-group>
          <field name="Confirm Password" :value="user.newPassword" type="password" v-model="user.confirmPassword"/>
        </form-group>
        <form-group>
          <button-cta :onClick="save">Save</button-cta>
        </form-group>
      </form>
    </div>
  </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'
import Spinner from '@/components/SpinnerIcon/spinner'
import {userMixin} from '@/mixins/userMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import {profileMixin} from '@/mixins/profileMixin'

export default {
  name: 'Profile',
  mixins: [userMixin, notificationMixin, profileMixin],
  components: {
    HeadingWrap,
    ButtonCta,
    Spinner,
    FormGroup,
    Field
  },
  data: () => ({
    loading: false
  }),
  methods: {
    save () {
      // const passwordRegex = new RegExp('/^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/')

      if (this.user.newPassword !== this.user.confirmPassword) {
        this.addNotification('warning', 'The password fields must match.')
        return
      }

      /*
      if (!passwordRegex.test(this.user.newPassword)) {
        this.addNotification('warning', 'The chosen password is too weak. Please ensure you have at least 6 characters containing 1 lowercase letter, 1 uppercase letter and 1 number.')
        return
      } */

      this.loading = true

      this.user.password = this.user.newPassword

      this.updateUser(this.user).then(() => {
        this.addNotification('success', 'Your profile has been updated.')
        this.loading = false
      }, error => {
        this.loading = false
        this.addNotification('danger', error)
      })
    }
  },
  created () {
    this.loading = true
    this.getCurrentUser().then(() => {
      this.loading = false
    })
  }
}
</script>

<style lang="scss">
    .usersEdit {
    }
</style>



// WEBPACK FOOTER //
// src/pages/profile.vue